import FeedTabs from 'Components/common/tabs/Tabs';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import FilterPopOver from 'Components/common/components/FilterPopOver';
import HeatMapProgress from 'Components/common/components/HeatMapProgress';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import { actions } from 'Slice/IndustriesSlice';
import { actions as GlobalSearchActions } from 'Slice/GlobalSearchResultsSlice';
import NewsTab from 'Components/industry/NewsTab';
import { actions as UiAction } from 'Slice/UISlice';
import {
  allValueInKeyOfArrayExists, getId, getLocalStorageObject, IsMobile, IsTablet,
} from 'Utils/UtilityFunctions';
import GlobalButton from 'Components/common/components/GlobalButton';
import { useEffect, useMemo, useState } from 'react';
import {
  newsFilter,
  newsLoading, selectedNewsArticles,
  selectedNewsFilter,
  selectIndusFollowLoading,
  selectIndustryAdded, selectIndustryName,
} from 'Selector/IndustriesSelector';
import { selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { Article } from 'Types/ArticleTypes';
import { Filter } from 'Types/FilterTypes';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import classNames from 'classnames';
import { ViewInterface } from 'Types/GlobalTypes';
import { selectViewTab } from 'Selector/UISelector';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import styled from 'styled-components';
import { maxTablet, maxWidth, retina } from 'Utils/utilsStyle';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import { Gilroy } from 'Components/gilroy/LazyGilroy';
import { useGilroy } from 'Utils/hooks/useGilroy';

const StyledWrapper = styled.div`
 .sub-header-main-wrapper {
   height: 75px;
   @media all and (max-width: ${maxWidth}), ${retina} {
     height: 64px;
   }
   .container {
     .sub-header-wrapper {
       padding: 20px 0px 14px;
       @media all and (max-width: ${maxWidth}), ${retina} {
         padding: 14px 0px;
       }
       @media all and (max-width: ${maxTablet}) {
         padding-bottom: 0px;
       }
       .heading-inner-page {
         .chat-bot-styled-wrapper {
           margin-top: 2px;
            @media all and (max-width: ${maxWidth}), ${retina} {
             margin-top: 10px;
            } 
             @media all and (max-width: ${maxTablet}) {
               margin-top: 11px;
             }
           .wrapper-btn {
             img {
               width: 62px;
               @media all and (max-width: ${maxWidth}), ${retina} {
                 width: 50px;
               }
               @media all and (max-width: ${maxTablet}) {
                 width: 43px;
                 margin-top: -11px;
               }
             }
             .btn-chatGpt-drawer {
               height: 35px;
               @media all and (max-width: ${maxWidth}), ${retina} {
                 height: 30px;
               }
               @media all and (max-width: ${maxTablet}) {
                 height: 26px;
               }
             }
           }
         }
         .button-follow {
           height: 26px;
         }
       }
     }
   }
 }
 `;

const IndustriesDetailPage = function IndustriesDetailPage() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const followLoading = useSelector(selectIndusFollowLoading);
  const [nav, setNavArray] = useState<string[]>([]);
  const newsArticles: Article[] = useSelector(selectedNewsArticles);
  const newsFilters: Filter[] = useSelector(newsFilter);
  const selectedNewsFilters: Filter[] = useSelector(selectedNewsFilter);
  const [filters, setFilters] = useState<Filter[]>([]);
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<Filter[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const dispatch = useDispatch();
  const loadingNews: boolean = useSelector(newsLoading);
  const name: string = useSelector(selectIndustryName);
  const added: boolean = useSelector(selectIndustryAdded);
  const tabView: ViewInterface = useSelector(selectViewTab);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;
  const isListView = tabView.view === 'listView';
  const getPath = getLocalStorageObject('ViewTab') as ViewInterface;
  const isMob = IsMobile();
  const { section } = useParams<Params>();
  const navigate = useNavigate();
  const id: number = getId();
  const sectionFlag = (
    section === 'news'
    || section === 'social');
  type TabsInterface = {
    [key: string]: JSX.Element
  };

  type Params = {
    section: string
  };

  const tabs: TabsInterface = {
    news: <NewsTab
      id={id}
      listview={isListView}
    />,
  };
  useEffect(() => {
    const params = {
      page: 1,
      industryId: id,
    };
    dispatch(actions.getNewsActivites(params));
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
  }, []);
  useEffect(() => {
    if (section === 'news') {
      if (selectedNewsFilters.length > 1) {
        setFilters(selectedNewsFilters);
        setSelectAll(allValueInKeyOfArrayExists(selectedNewsFilters, 'isSelected', true));
      } else {
        setFilters(newsFilters);
        setPreviousNewsFiltersApplied(newsFilters);
        setSelectAll(allValueInKeyOfArrayExists(newsFilters, 'isSelected', true));
      }
    }
  }, [newsFilters, section]);

  const followIndustry = () => {
    const industry = {
      category: '',
      digestContent: true,
      fullimage: '',
      id,
      image: '',
      name,
      type: '',
      user: '',
      selected: false,
      added: false,
    };
    dispatch(actions.addingIndustry(industry));
    dispatch(GlobalSearchActions.searchIndustryFollowLoading(industry.id));
  };
  useEffect(() => {
    if (selectedNewsFilters.length < 1) {
      const navArray: string[] = [];
      if (newsArticles.length) {
        navArray.push('News');
      }
      setNavArray(navArray);
    }
  }, [newsArticles]);
  const onChangeFilters = (flag: boolean, idx: string) => {
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === idx) {
        return { ...filter, isSelected: flag };
      } return filter;
    });
    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
  };
  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };
  const applyFilterHandler = () => {
    const params = {
      page: 1,
      industryId: id,
      filters,
    };

    if (section === 'news') dispatch(actions.getNewsActivites(params));
    setPreviousNewsFiltersApplied(filters);
  };

  const checkForApplyFilter = () => {
    for (let i = 0; i < filters.length; i += 1) {
      if (filters[i].isSelected !== previousNewsFiltersApplied[i]?.isSelected) return false;
    }
    return true;
  };

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  useEffect(() => {
    dispatch(UiAction.isTabView({
      view: getPath.view,
    }));
  }, [getPath.view]);

  return (
    <StyledWrapper>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon onClick={() => navigate(-1)} />
          {loadingNews && name === '' ? <SkeletonCustom width="340px" height="30px" margin="0px 0px 0px 5px" /> : <h1 className="heading text-truncate-two-line">{name}</h1>}
          {!loadingNews && !added && !isMob ? (
            <div className="global-btn-industries">
              <GlobalButton
                title={!followLoading ? 'Follow' : 'Following'}
                textColor="#ffffff"
                bgColor="#001760"
                borderRadius="25px"
                PaddingSm="0px 16px"
                heightSm="25px"
                height="30px"
                LeftSpace="10px"
                buttonClassName="button-follow"
                disabled={followLoading}
                onButtonClick={followIndustry}
              />
            </div>
          ) : null}

        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={IsTablet()} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <SubNavBarPrimary>
        <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll">
          {!isMob && (
            <div className="head-wrap" />
          )}
          {isMob ? (
            <div className="global-btn-industries sub-primary-nav-follow">
              {!loadingNews && !added && (
                <GlobalButton
                  title={!followLoading ? 'Follow' : 'Following'}
                  textColor="#ffffff"
                  bgColor="#001760"
                  borderRadius="8px"
                  PaddingSm="0px 16px"
                  heightSm="25px"
                  height="30px"
                  LeftSpace="10px"
                  buttonClassName="button-follow"
                  disabled={followLoading}
                  onButtonClick={followIndustry}
                />
              )}
            </div>
          ) : null}
          <div className="tips-placeholder d-flex justify-content-center">
            <FeedTabs baseComponentPath="industry" scrollStartToWindow tabsName={nav} loading={loadingNews} elementTarget="tabs-details" headerAppendTab />
          </div>
          <div className="right-side-sub-header">
            <div className={classNames('view-tabs', {
              notdisabledTabs: sectionFlag,
            })}
            >
              <ViewTabs
                disabled={!sectionFlag}
                listView={isListView}
              />
            </div>
            <div className={classNames('filter-placeholder', {
              notDisabledFilter: true,
            })}
            >
              <FilterPopOver
                loading={false}
                filters={filters}
                selectAll={selectAll}
                onChangeFilters={onChangeFilters}
                onClickHandler={onClickHandler}
                applyFilterHandler={applyFilterHandler}
                disableApplyBtn={checkForApplyFilter()}
                iconMode={IsTablet()}
              />
            </div>
          </div>
        </div>
      </SubNavBarPrimary>
      <div className="container">
        <DrawerPeopleGroup
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          disableDrop
          noButton
        />
        <div className="mt-c-10">
          <HeatMapProgress pulse={[]} />
        </div>
        {useMemo(
          () => (
            <div>{tabs[section?.toLowerCase() || 'news']}</div>
          ),
          [section, isListView],
        )}

      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </StyledWrapper>
  );
};

export default IndustriesDetailPage;
